import { __rest } from "tslib";
import React, { useEffect, useMemo, useRef } from "react";
import { BottomAxis } from "../BottomAxis";
import { scaleLinear } from "../assets/d3";
import { dateToUntilMinutes } from "./dateStringUtils";
export const TimeSlider = (_a) => {
    var { width, height, min, max, value, onChange } = _a, restProps = __rest(_a, ["width", "height", "min", "max", "value", "onChange"]);
    const inputRef = useRef(null);
    const fixedMin = Number((Math.ceil(min * 100) / 100).toFixed(2));
    const fixedMax = Number((Math.floor(max * 100) / 100).toFixed(2));
    useEffect(() => {
        const newValue = Number(inputRef.current.value);
        if (value !== newValue) {
            onChange(newValue);
        }
    }, [min, max]);
    const scale = useMemo(() => scaleLinear().domain([fixedMin, fixedMax]).range([0, width]), [min, max, width]);
    const handleChange = (event) => {
        const newValue = Number(event.target.value);
        onChange(newValue);
    };
    return (React.createElement("div", { className: "time-slider", style: {
            height: `${height}px`,
            width: `${width}px`,
            margin: "35px 0px",
        } },
        React.createElement("div", { className: "focus-realtime_date_label", style: {
                left: scale(value) + "px",
            } }, dateToUntilMinutes(value)),
        React.createElement("input", Object.assign({ ref: inputRef, type: "range", style: {
                width: `${width}px`,
                backgroundColor: "#fafafa",
            }, min: fixedMin, max: fixedMax, step: 0.01, value: value, onChange: handleChange }, restProps)),
        React.createElement(BottomAxis, { height: height, width: width, scale: scale, formatter: dateToUntilMinutes })));
};
//# sourceMappingURL=TimeSlider.js.map